import { ColDef, GridReadyEvent } from "@ag-grid-community/core";
import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { ItemDetailLog } from "app/model/entities/entity-model";
import { AgFns, GridOptionsExt } from "app/shared/ag-fns";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";

@Component({
  selector: "uni-item-detail-log-grid",
  templateUrl: "./item-detail-log-grid.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ItemDetailLogGridComponent extends DomainBaseComponent implements OnChanges {
  @Input() itemDetailId: string | null;

  logGridOptions: GridOptionsExt;
  logs: ItemDetailLog[] = [];

  constructor(domainService: DomainService) {
    super(domainService);
    this.logGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onLogGridReady.bind(this),
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if ("itemDetailId" in changes) {
      await this.reload();
    }
  }

  private async reload() {
    if (!this.itemDetailId) {
      this.logs = [];
      this.logGridOptions.apiX?.setGridOption("rowData", this.logs);
      return;
    }
    const q = this.dbQueryService.createItemDetailLogQuery(this.itemDetailId);
    this.logs = await q.execute();
    this.logGridOptions.apiX?.setGridOption("rowData", this.logs);
  }

  private onLogGridReady(event: GridReadyEvent) {
    const colDefs: ColDef[] = [
      { headerName: "Item Detail", field: "itemDetailId", width: 120 },
      { headerName: "Owned", field: "account.accountName", width: 120 },
      { headerName: "Item Bin", field: "itemBin.name" },
      {
        headerName: "Purchase Order",
        field: "poDetail.poHeaderId",
        width: 140,
      },
      {
        headerName: "Job Order",
        field: "joDetail.joHeaderId",
        width: 140,
      },
      { headerName: "JO Account", field: "joDetail.joHeader.account.accountName" },
      { headerName: "Status", field: "itemDetailStatus.name" },
      { headerName: "Barcode Status", field: "barcodePrintStatus.name" },
      { headerName: "Created", field: "crtnTs", width: 160 },
      { headerName: "User", field: "crtnUserInit", width: 80 },
    ];
    const sortModel = [{ colId: "crtnTs", sort: "desc" as const }];
    AgFns.initGrid(event, colDefs, sortModel);
  }
}
